import {
  autocomplete,
  keywordsById,
  type Keyword as KeywordType,
} from '@/api/keywordApi/client';

const api = {autocomplete, keywordsById};

export default api;

export type Keyword = NonNullable<KeywordType>;

export {
  isCityKeyword,
  isCountryKeyword,
  isDestinationKeyword,
  isHotelKeyword,
} from '@/api/keywordApi/utils';

// eslint-disable-next-line no-explicit-type-exports/no-explicit-type-exports
export {KeywordTypes} from '@/api/keywordApi/client';
